<template>
    <div
      class="rounded-xl flex flex-col flex-1 overflow-hidden"
    >
      <div
        class="flex flex-col flex-1 overflow-hidden col-span-3 rounded-e-xl bg-white rounded-xl shadow-lg mb-4 border"
      >
        <div class="flex flex-col flex-1 w-full overflow-hidden">
          <!-- Header -->
          <div
            class="flex items-center gap-3 p-4 rounded-t-xl flex-shrink-0 border-b"
          >
            <Avatar
              class="bg-primary-900 me-4"
              shape="circle"
              size="large"
              :image="require('@/assets/assistant-icon.png')"
            />
            <div class="flex justify-between w-full">
              <div class="font-semiBold text-sm">
                {{ $t("chat.assistant.title") }}
              </div>
            </div>
          </div>

          <!-- Messages -->
          <div ref="messagesScroll" class="flex flex-col flex-1 overflow-y-auto bg-surface-50 py-2">
            <div class="relative">
              <div
                v-if="observedDay"
                class="sticky top-0 left-1/2 transform -translate-x-1/2 w-fit text-white px-3 py-1 rounded-full text-sm z-10"
              >
                {{ observedDay }}
              </div>

              <div
                ref="messagesList"
                id="messagesList"
                class="overflow-y-auto px-3"
              >
                <div>
                  <div
                    v-for="(msg, i) in assistantChat
                      ? assistantChat.messages.slice().reverse()
                      : []"
                    :key="i"
                    class="mb-1"
                  >
                    <div :ref="`${msg.id}`" class="grid justify-items-stretch">
                      <div
                        v-if="
                          !isSameDayMessages(
                            msg.time,
                            i == 0
                              ? 0
                              : assistantChat.messages.slice().reverse()[i - 1]
                                  .time
                          )
                        "
                        class="text-primary-900 text-sm my-2 w-fit justify-self-center bg-nature-grey py-1 px-2 rounded-lg"
                      >
                        {{ getConversationTime(msg.time, 3) }}
                      </div>

                      <div
                        v-if="msg.type === 1"
                        class="text-sm text-primary-900 bg-white px-4 py-2 rounded-lg shadow-md my-2 w-fit justify-self-end"
                      >
                        {{ msg.message }}
                        <div class="text-left text-xs text-gray-500 mt-1">
                          {{ getMessageTimeFormat(msg.time) }}
                        </div>
                      </div>
                      <div
                        v-else
                        class="text-sm text-dark bg-nature-grey px-4 py-2 rounded-lg shadow-md my-2 w-fit justify-self-start"
                      >
                        <div class="markdown-body" v-html="renderMarkdown(msg.message)"></div>
                        <div class="text-end text-xs text-gray-500 mt-1">
                          {{ getMessageTimeFormat(msg.time) }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Input -->
          <div class="flex items-center gap-2 p-4 rounded-b-xl border-t">
            <Textarea
              v-model="messageText"
              autoResize
              rows="1"
              class="w-11/12"
              :placeholder="$t('chat.message_input_placeholder')"
              @keydown.enter="handleEnter"
            />
            <Button
              class="!text-primary-500 hover:!bg-primary-100 rounded-full p-2"
              @click="sendMessage"
            >
              <v-icon
                :class="[$i18n.locale === 'ar' ? 'transform scale-x-[-1]' : '']"
                >mdi-send</v-icon
              ></Button
            >
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { Textarea, Button, Avatar } from "primevue";
import { marked } from "marked";

export default {
  components: {
    Textarea,
    Button,
    Avatar,
  },
  data() {
    return {
      messageLoading: "",
      observer: null,
      messagesLimit: 30,
      messagesLabels: [],
      observeList: [],
      observedDay: null,
      converseHeight: 0,
      scrollInvoked: 0,
      messageText: "",
    };
  },
  computed: {
    ...mapGetters([
      "assistantChat",
      "assistantAsk",
      "avatar",
      "uname",
      "chatSocket",
    ]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
    profileAvater() {
      return this.avatar && this.avatar != ""
        ? this.avatar
        : require("../assets/user-avatar.png");
    },
    isInSendingWait() {
      if (!this.assistantChat) {
        return true;
      }
      if (this.assistantChat?.messages.length == 0) {
        return false;
      }
      const updatedMsgs = JSON.parse(
        JSON.stringify(this.assistantChat.messages)
      );
      const msgIdx = updatedMsgs.findIndex(
        (msg) => msg.waiting == true || msg.loading == true
      );
      return msgIdx != -1;
    },
    getAssistantConversationID() {
      if (this.assistantChat?.conversation_id) {
        return this.assistantChat?.conversation_id;
      }
      return uuidv4();
    },
  },
  methods: {
    ...mapMutations(["setAssistantChat", "setAssistantAsk"]),
    ...mapActions(["SetMessageDialog"]),
    renderMarkdown(text) {
      return marked.parse(text || "");
    },
    onScroll() {
      this.scrollInvoked++;
    },
    setupObserver() {
      if (!this.$refs.messagesList) {
        return;
      }
      this.observeList = [];
      this.observedDay = null;
      // console.log("My setUpObserver", this.$refs.messagesList);
      if (this.observer) {
        this.observer.disconnect();
      }
      const options = {
        root: this.$refs.messagesList,
        rootMargin: "0px",
        threshold: 0.7,
      };
      this.observer = new IntersectionObserver(this.handleShowingDay, options);
      this.messagesLabels.forEach((messageDay) => {
        // console.log("My day Ele", messageDay, this.$refs[messageDay][0]);
        this.observer.observe(this.$refs[messageDay][0]);
      });
    },
    handleShowingDay(entries) {
      entries.forEach((entry) => {
        // console.log(
        //   "My intersecting, parent, entry , value",
        //   entry.isIntersecting,
        //   this.$refs.messagesList.scrollTop,
        //   entry.target.offsetTop,
        //   entry.target.innerText
        // );
        if (!this.assistantChat) {
          return;
        }
        const value = entry.target.innerText;
        if (!this.observeList.includes(value)) {
          this.observeList.push(value);
          if (this.observeList.length != this.messagesLabels.length) {
            return;
          }
        }
        const parentOffset = this.$refs.messagesList.scrollTop;
        const isIntersect = entry.isIntersecting;
        const entryOffset = entry.target.offsetTop;
        const showPrevious = !isIntersect && parentOffset < entryOffset;
        const showValueCond =
          (isIntersect && parentOffset < entryOffset) ||
          (isIntersect && entryOffset < 0) ||
          (!isIntersect && parentOffset > entryOffset);
        if (value.toLowerCase() == this.$t("chat.time.today")) {
          if (showPrevious) {
            const idx = this.observeList.findIndex((val) => val == value);
            this.observedDay =
              idx != -1 && idx > 0 ? this.observeList[idx - 1] : value;
          } else {
            this.observedDay = null;
          }
          return;
        }
        if (showValueCond) {
          this.observedDay = value;
        } else if (showPrevious) {
          const idx = this.observeList.findIndex((val) => val == value);
          this.observedDay =
            idx != -1 && idx > 0 ? this.observeList[idx - 1] : value;
        }
      });
    },
    onResize() {
      this.converseHeight = window.innerHeight;
    },
    getConversationTime(lastTime, type) {
      const messageDay = moment.unix(+lastTime).format("YYYY-MM-DD");
      const today = moment().format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(moment(today), "day");
      if (sameDayCond && type != 3) {
        return moment.unix(+lastTime).format("HH:mm");
      } else if (sameDayCond && type == 3) {
        return this.$t("chat.time.today");
      }
      if (moment(today).diff(moment(messageDay), "days") == 1) {
        return this.$t("chat.time.yesterday");
      }
      const weekEarlier = moment().add(-7, "days").format("YYYY-MM-DD");
      if (moment(weekEarlier).isBefore(moment(messageDay))) {
        return moment.unix(+lastTime).locale(this.currentLocal).format("dddd");
        // return moment.unix(+lastTime).format("dddd");
      }
      return messageDay;
    },
    getMessageDate(msgTime) {
      return moment.unix(+msgTime).format("YYYY-MM-DD");
    },
    getMessageTimeFormat(msgTime) {
      return moment.unix(+msgTime).format("HH:mm");
    },
    isSameDayMessages(msgTime, prevMsgTime) {
      const messageDay = moment.unix(+msgTime).format("YYYY-MM-DD");
      const prevMessageDay = moment.unix(+prevMsgTime).format("YYYY-MM-DD");
      const sameDayCond = moment(messageDay).isSame(
        moment(prevMessageDay),
        "day"
      );
      if (sameDayCond) {
        return true;
      }
      if (!sameDayCond || msgTime == prevMessageDay) {
        if (!this.messagesLabels.includes(messageDay)) {
          this.messagesLabels.push(messageDay);
        }
      }
      return false;
    },
    scrollToLastMessage() {
      // The actual scroll container is the outer "Messages" wrapper
      // (ref messagesScroll); messagesList itself has no height constraint
      // and does not scroll. Scroll both to be safe across layouts.
      const scrollToBottom = () => {
        const container = this.$refs.messagesScroll;
        if (container) container.scrollTop = container.scrollHeight;
        const list = this.$refs.messagesList;
        if (list) list.scrollTop = list.scrollHeight;
      };
      this.$nextTick(() => {
        scrollToBottom();
        // Run again on the next frame so late layout (rendered markdown,
        // day separators, fonts) is included and we land at the very bottom.
        requestAnimationFrame(scrollToBottom);
      });
    },
    handleEnter(e) {
      if (e.shiftKey) return; // Allow newline
      e.preventDefault();
      this.sendMessage(e);
    },
    sendMessage(e) {
      e.preventDefault();
      if (this.messageText.trim() == "" || this.isInSendingWait) {
        return;
      }

      if (!this.assistantChat.conversation_id) {
        this.setAssistantChat({ ...this.assistantChat, conversation_id: uuidv4() });
      }

      let message = {
        message: this.messageText.trim(),
        time: moment().unix().toString(),
        type: 1,
        id: uuidv4(),
        // waiting: true,
      };
      this.updateChatMessages(message);
      this.chatSocket.send(
        JSON.stringify({
          type: 41,
          message_id: message.id,
          from: this.uname,
          text: message.message,
          conversation_id: this.getAssistantConversationID,
          time: message.time,
        })
      );
      // this.updateChatMessages({
      //   message: "This is an automatic reply from AI assistant",
      //   time: moment().unix().toString(),
      //   type: 2,
      //   id: uuidv4(),
      // });
      // this.setAssistantAsk(message);
      this.messageText = "";
    },
    updateChatMessages(message) {
      let exist = this.assistantChat.messages.length > 0;
      let isSamePrevMsgDay = true;
      if (exist) {
        isSamePrevMsgDay = this.isSameDayMessages(
          message.time,
          this.assistantChat.messages[0].time
        );
      }
      if (!isSamePrevMsgDay) {
        this.messagesLabels = [];
      }
      const updatedMsgs = JSON.parse(
        JSON.stringify(this.assistantChat.messages)
      );
      updatedMsgs.unshift(message);

      this.setAssistantChat({ ...this.assistantChat, messages: updatedMsgs });
      if (!isSamePrevMsgDay) {
        setTimeout(() => {
          this.setupObserver();
        }, 500);
      }
      this.scrollToLastMessage();
    },
    resendMessage(msgId) {
      if (this.isInSendingWait) {
        return;
      }
      // this.messageLoading = msgId;
      const msgIdx = this.assistantChat.messages.findIndex(
        (msg) => msg.id == msgId
      );
      const updatedMsgs = JSON.parse(
        JSON.stringify(this.assistantChat.messages)
      );
      updatedMsgs[msgIdx].loading = true;
      this.chatSocket.send(
        JSON.stringify({
          type: 41,
          message_id: updatedMsgs[msgIdx].id,
          from: this.uname,
          text: updatedMsgs[msgIdx].message,
          conversation_id: this.getAssistantConversationID,
          time: updatedMsgs[msgIdx].time,
        })
      );
      // this.setAssistantAsk({
      //   message: this.assistantChat.messages[msgIdx].message,
      //   type: 1,
      //   id: msgId,
      // });
      this.setAssistantChat({ ...this.assistantChat, messages: updatedMsgs });
      // setTimeout(() => {
      //   this.messageLoading = "";
      // }, 800);
    },
  },
  watch: {
    async assistantAsk(val) {
      // if (!val || val?.type == 1) {
      //   return;
      // }
      if (!val) {
        return;
      }
      this.updateChatMessages(val);
    },
  },
  //   async created() {
  //     // await this.initChat();
  //   },
  mounted() {
    this.onResize();
    if (!this.assistantChat) {
      this.setAssistantChat({ messages: [], conversation_id: "" });
    } else if (this.assistantChat.messages.length > 0) {
      this.messagesLabels = [];
      setTimeout(() => {
        this.setupObserver();
      }, 500);
      this.scrollToLastMessage();
    }
  },
  //   unmounted() {
  //     this.setCurrentOmniID(null);
  //     // clearTimeout(this.closingTime);
  //   },
};
</script>

<style scoped>
.markdown-body :deep(p) { margin: 0 0 0.5em; }
.markdown-body :deep(p:last-child) { margin-bottom: 0; }
.markdown-body :deep(ul),
.markdown-body :deep(ol) { padding-left: 1.25em; margin: 0.25em 0; }
.markdown-body :deep(li) { margin: 0.1em 0; }
.markdown-body :deep(code) { background: rgba(0,0,0,0.08); padding: 0.1em 0.3em; border-radius: 3px; font-size: 0.9em; }
.markdown-body :deep(pre) { background: rgba(0,0,0,0.08); padding: 0.6em 0.8em; border-radius: 6px; overflow-x: auto; margin: 0.4em 0; }
.markdown-body :deep(pre code) { background: none; padding: 0; }
.markdown-body :deep(h1), .markdown-body :deep(h2), .markdown-body :deep(h3) { font-weight: 600; margin: 0.4em 0 0.2em; }
.markdown-body :deep(strong) { font-weight: 600; }
.markdown-body :deep(blockquote) { border-left: 3px solid #ccc; margin: 0.4em 0; padding-left: 0.75em; color: #555; }
</style>
